import axios from 'axios';
import { store } from './store/store';
import { clearToken, setToken } from './store/slices/authSlice';
import { setError } from './store/slices/apiErrorSlice';

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let currentlyRefreshingAuth: boolean = false;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const url: string = error.request.responseURL;

    if (!url.includes('auth') && error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!currentlyRefreshingAuth) {
        currentlyRefreshingAuth = true;
        
        try {
          const response = await api.post('/auth/refresh', {
            refreshToken: localStorage.getItem('refreshToken'),
          })
            .finally(() => {
              currentlyRefreshingAuth = false;
            });

          const newAccessToken = response.data.access_token;
          store.dispatch(setToken(newAccessToken));
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          localStorage.setItem('jwtToken', newAccessToken);
          return axios(originalRequest);
        } catch (err) {
          store.dispatch(clearToken());
          window.location.href = '/auth';
        }
      }
    }

    if (!url.includes('auth') && !url.includes('ping')) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong. Please try again.';
      store.dispatch(setError(message));
    }

    return Promise.reject(error);
  }
);

export default api;